export default {
      id: "survey-r-icon-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite-46b249.svg#survey-r-icon-usage",
      toString: function () {
        return this.url;
      }
    }